export const routes = Object.freeze({
  laborRates: '/labor-rates',
  rateTemplatesEdit: '/rate-templates/:laborRateId/edit',
  rateTemplatesCreate: '/rate-templates/create',
});

export const paths = Object.values(routes);
